import React from 'react';

const EngineeringDrawings = () => {
  return (
    <div>
      <h1>Welcome to the EngineeringDrawings Page</h1>
      <p>This is the default content inside the Dashboard.</p>
    </div>
  );
};

export default EngineeringDrawings;
